import { render, staticRenderFns } from "./CacheManagement.vue?vue&type=template&id=1822712c&scoped=true"
import script from "./CacheManagement.vue?vue&type=script&lang=js"
export * from "./CacheManagement.vue?vue&type=script&lang=js"
import style0 from "./CacheManagement.vue?vue&type=style&index=0&id=1822712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822712c",
  null
  
)

export default component.exports